import { render, staticRenderFns } from "./DoorKing.vue?vue&type=template&id=b8210f38&"
import script from "./DoorKing.vue?vue&type=script&lang=js&"
export * from "./DoorKing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports